export default __webpack_public_path__ + "static/media/White wall-mini.5ecd0557.jpg";